<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import RealEstateCommissionPlanInstallments from './RealEstateCommissionPlanInstallments.vue';
import RealEstateCommissionPlanPaymentSummary from './RealEstateCommissionPlanPaymentSummary.vue';
import RealEstateCommissionPlanSaleSummary from './RealEstateCommissionPlanSaleSummary.vue';

const props = defineProps({
  plan: { type: Object, required: true },
});

const emit = defineEmits(['edit', 'editInstallment', 'previewInstallment']);
const { t } = useI18n();
const installments = computed(() => props.plan.parcelas_empresa || []);
const menuItems = computed(() => [
  {
    action: 'edit',
    value: 'edit',
    label: t('REAL_ESTATE_COMMISSION_INSTALLMENT.ACTIONS.EDIT'),
    icon: 'i-lucide-pencil',
  },
  {
    action: 'preview',
    value: 'preview',
    label: t('REAL_ESTATE_COMMISSION_INSTALLMENT.ACTIONS.PREVIEW'),
    icon: 'i-lucide-eye',
  },
]);
const money = value =>
  value?.amount ?? t('REAL_ESTATE_COMMISSION_PLAN.COMMON.EMPTY_MONEY');
</script>

<template>
  <section class="grid gap-5 xl:grid-cols-[1.35fr_1fr]">
    <RealEstateCommissionPlanSaleSummary :plan="plan" :money="money" />
    <RealEstateCommissionPlanPaymentSummary :plan="plan" @edit="emit('edit')" />
  </section>
  <RealEstateCommissionPlanInstallments
    :installments="installments"
    :menu-items="menuItems"
    :money="money"
    @edit="emit('editInstallment', $event)"
    @preview="emit('previewInstallment', $event)"
  />
</template>
